<template>
    <div>
        <strong>When will this message be sent</strong>
        <div v-if="template_context === 'shipping-new-tracking-number'">
            <ul>
                <li>RedChirp sends this message whenever it observes a new tracking number</li>
                <li>If the tracking number is associated with a shipment scheduled for a future date, RedChirp will delay sending the message until the scheduled ship date arrives</li>
                <ul>
                    <li>If you change the scheduled ship date, RedChirp adjusts accordingly and will send the message on the updated ship date</li>
                </ul>
            </ul>
        </div>
        <div v-if="template_context === 'shipping-exception'">
            <ul>
                <li>RedChirp sends this message whenever it observes a shipping exception (for example, that a package is undeliverable because the address does not exist)</li>
                <li>There are a wide variety of exceptions that the carriers encounter &mdash; some are serious, such a package has been lost, while others are comparatively minor, such as a hours delay due to bad weather.</li>
            </ul>
        </div>
        <div v-if="template_context === 'shipping-on-weather-hold'">
            <ul>
                <li>RedChirp sends this message whenever it learns that a package has been put on a weather hold (e.g. held in the warehouse because the destination is too hot for wine or other temperature-senstive goods)</li>
                <li>You must have an integration enabled that provides RedChirp with detailed tracking information for the package in question</li>
            </ul>
        </div>
        <div v-if="template_context === 'shipping-weather-hold-release'">
            <ul>
                <li>RedChirp sends this message whenever it learns that a package that was previously on weather hold is released for shipment</li>
                <li>After release, other shipping lifecycle events (e.g. 'Shipping: First In Transit') will still be sent</li>
                <li>You must have an integration enabled that provides RedChirp with detailed tracking information for the package in question</li>
            </ul>
        </div>
        <div v-if="template_context === 'shipping-first-in-transit'">
            <ul>
                <li>RedChirp sends this message whenever it learns that a package has had its first in-transit event (e.g. picked up by carrier, etc.)</li>
                <li>You must have an integration enabled that provides RedChirp with detailed tracking information for the package in question</li>
            </ul>
        </div>
        <div v-if="template_context === 'shipping-out-for-delivery'">
            <ul>
                <li>RedChirp sends this message whenever it learns that a package is out for delivery</li>
                <li>You must have an integration enabled that provides RedChirp with detailed tracking information for the package in question</li>
            </ul>
        </div>
        <div v-if="template_context === 'shipping-delivery-attempt-failed'">
            <ul>
                <li>RedChirp sends this message whenever it learns that a delivery attempt for a package has failed</li>
                <li>You must have an integration enabled that provides RedChirp with detailed tracking information for the package in question</li>
            </ul>
        </div>
        <div v-if="template_context === 'shipping-available-for-pickup'">
            <ul>
                <li>RedChirp sends this message whenever it learns that a package is being held for pickup by the customer (e.g. the package is at a FedEx "hold at" location, etc.)</li>
                <li>You must have an integration enabled that provides RedChirp with detailed tracking information for the package in question</li>
            </ul>
        </div>
        <div v-if="template_context === 'shipping-delivered'">
            <ul>
                <li>RedChirp sends this message whenever it learns that a package has been delivered to a customer</li>
                <li>You must have an integration enabled that provides RedChirp with detailed tracking information for the package in question</li>
            </ul>
        </div>
        <div v-if="template_context === 'shipping-picked-up'">
            <ul>
                <li>RedChirp sends this message whenever it learns that a package has been picked up by a customer</li>
                <li>You must have an integration enabled that provides RedChirp with detailed tracking information for the package in question</li>
            </ul>
        </div>
        <div v-if="template_context === 'shipping-expected-delivery-date-changed'">
            <ul>
                <li>RedChirp sends this message whenever it learns that the expected delivery date of a package has changed</li>
                <li>This message is <strong>not</strong> sent when RedChirp <i>first</i> learns that a package has an expected delivery date</li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ShippingMessageInfo',

    props: {
        template_context: {
            type: String,
            required: true
        }
    }
}
</script>
